import React, { useEffect, useState } from 'react';

import styleClasses from './css/Popup.module.scss'

const Popup = ({ open, setOpenPopup, title, text, buttonText, buttonFunction, buttonLoading, children, // children prop 추가
}) => {
  const [active, setActive] = useState('');
  useEffect(() => {
    setActive(open ?  styleClasses.active : '');
    
  }, [open, setOpenPopup, active])

  
  return (
    <>
      <div className={`${ styleClasses.commonPopupBackdrop } ${ active }`} onClick={ () => { setActive(''); setOpenPopup(false); } }></div>
      <div className={`${ styleClasses.commonPopup } ${ active }`}>
        <div className={ styleClasses.inner }>
          <div className={ styleClasses.header }>
            <div className={ styleClasses.title }>
              {
                (title && title !== '')
                &&
                <h1 dangerouslySetInnerHTML={{ __html: title }} />
              }
            </div>
            <div className={ styleClasses.closeButton }>
              <div className="commonIcon">
                <button onClick={ () => { setActive(''); setOpenPopup(false); } }>
                  <i className='closeWhite w32'></i>
                </button>
              </div>
            </div>
          </div>
          {
              children ? (
                <div className={ styleClasses.content }>
                  { children }
                </div>
              ) : (
                text && (
                  <div className={ styleClasses.content }>
                    <p dangerouslySetInnerHTML={{ __html: text }}/>
                  </div>
                )
              )
          }
            {
              buttonFunction &&
              (
                <div className={ styleClasses.footer }>
                  <div className="commonButton fullWidth">
                    <button onClick={ () => { setActive(''); setOpenPopup(false); } }>
                      닫기
                    </button>
                  </div>
                  <div className="commonButton fullWidth">
                    <button className='black' onClick={ () => { setActive(''); buttonFunction(); } }>
                      {
                        buttonText !== '' ? buttonText : '확인'
                      }
                      <div className={`buttonLoading ${ buttonLoading && 'active' }`}>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </button>
                  </div>
              </div>
              )
            }
        </div>
      </div>
    </>
  );
};

export default Popup;
